import { ThemeScreenProps } from "../types";
import { resolveColor, MOCK_SIDEBAR_CATS, MOCK_MODIFIER_GROUPS, DEFAULT_THEME_COLORS } from "../constants";
import {
  DetailScreen,
  DetailBody,
  DetailSidebar,
  SidebarCat,
  DetailCatEmoji,
  DetailCatLabel,
  DetailMainContent,
  DetailHeader,
  BackBtn,
  ItemImageBox,
  ItemInfo,
  DetailItemName,
  ItemSubtitle,
  DetailItemPrice,
  ModifierScroll,
  ModifierGroup,
  ModifierHeader,
  ModifierChip,
  ModifierRequired,
  OptionsRow,
  OptionCard,
  OptionEmoji,
  OptionLabel,
  ExtraPriceBadge,
  BottomBar,
  QtyControl,
  AddToCartBtn,
} from "../styles";

function ItemDetailScreen({ colors }: ThemeScreenProps) {
  const bg = resolveColor(colors.backgroundColor, DEFAULT_THEME_COLORS.backgroundColor);
  // Sidebar/surface are no longer merchant-configurable — fixed neutral,
  // with the accent brand color marking the selected category.
  const sidebarBg = "#ffffff";
  const surfaceBg = "#ffffff";
  const primaryText = resolveColor(colors.primaryTextColor, DEFAULT_THEME_COLORS.primaryTextColor);
  const secondaryText = resolveColor(colors.secondaryTextColor, DEFAULT_THEME_COLORS.secondaryTextColor);
  const accent = resolveColor(colors.secondaryColor, DEFAULT_THEME_COLORS.secondaryColor);
  const sidebarBorder = accent;
  const primary = resolveColor(colors.primaryColor, DEFAULT_THEME_COLORS.primaryColor);

  return (
    <DetailScreen $bg={bg}>
      <DetailBody>
        <DetailSidebar $bg={sidebarBg}>
          {MOCK_SIDEBAR_CATS.map((cat) => (
            <SidebarCat key={cat.label} $selected={cat.selected} $border={sidebarBorder}>
              <DetailCatEmoji>{cat.emoji}</DetailCatEmoji>
              <DetailCatLabel>{cat.label}</DetailCatLabel>
            </SidebarCat>
          ))}
        </DetailSidebar>

        <DetailMainContent>
          <DetailHeader>
            <BackBtn $color={primary}>← Back</BackBtn>
            <ItemImageBox>🍝</ItemImageBox>
            <ItemInfo>
              <DetailItemName $color={primaryText}>Create your own CUP</DetailItemName>
              <ItemSubtitle $color={secondaryText}>Best seller</ItemSubtitle>
              <DetailItemPrice $color={accent}>$10.00</DetailItemPrice>
            </ItemInfo>
          </DetailHeader>

          <ModifierScroll>
            {MOCK_MODIFIER_GROUPS.map((group) => (
              <ModifierGroup key={group.id} $bg={bg}>
                <ModifierHeader>
                  <ModifierChip $color={primary}>{group.label}</ModifierChip>
                  <ModifierRequired $color={secondaryText}>{group.required}</ModifierRequired>
                </ModifierHeader>
                <OptionsRow>
                  {group.options.map((opt, i) => (
                    <OptionCard key={opt} $bg={surfaceBg}>
                      <OptionEmoji>{group.emojis[i]}</OptionEmoji>
                      <OptionLabel $color={primaryText}>{opt}</OptionLabel>
                      {group.extraPriceIdx === i && (
                        <ExtraPriceBadge $color={accent}>{group.extraPrice}</ExtraPriceBadge>
                      )}
                    </OptionCard>
                  ))}
                </OptionsRow>
              </ModifierGroup>
            ))}
          </ModifierScroll>

          <BottomBar>
            <QtyControl $color={primary}>
              <button>−</button>
              <span>1</span>
              <button>+</button>
            </QtyControl>
            <AddToCartBtn $color={primary}>
              <span>ADD TO CART</span>
              <span>$10.00</span>
            </AddToCartBtn>
          </BottomBar>
        </DetailMainContent>
      </DetailBody>
    </DetailScreen>
  );
}

export default ItemDetailScreen;
